module.exports = __webpack_public_path__ + "img/WSFS_Wealth_institutional_services_logo.472960e8.png";